module.exports = __webpack_public_path__ + "img/xingtansuo.acfcff44.svg";